import helpers from '@/services/helpers';
import type { InjectionKey, Plugin } from 'vue';

export const HelpersKey: InjectionKey<typeof helpers> = Symbol('helpers');
declare module 'vue' {
  interface ComponentCustomProperties {
    $helpers: typeof helpers;
  }
}

const helperPlugin: Plugin = {
  install: (app) => {
    app.config.globalProperties.$helpers = helpers;
    app.provide(HelpersKey, helpers);
  },
};

export default helperPlugin;
